import React from 'react'
import HeaderFive from "../components/header/HeaderFive";
import BannerFive from "../components/banner/BannerFive";
import ServiceFive from "../components/service/ServiceFive";
import MarketingSolution from "../components/businessgoal/MarketingSolution";
import CallToActionFive from "../components/calltoaction/CallToActionFive";
import BusinessCaseThree from "../components/businesscase/BusinessCaseThree";
import CounterUpThree from "../components/counterup/CounterUpThree";
import BusinessCaseFour from "../components/businesscase/BusinessCaseFour";
import TestimonialThree from "../components/testimonials/TestimonialThree";
import BlogFive from "../components/blog/BlogFive";
import BrandFive from "../components/brand/BrandFive";
import FooterFive from "../components/footer/FooterFive";

function HomeOne() {
    return (
        <div className='home-blue2'>

            <HeaderFive />
            <BannerFive />
            <ServiceFive />
            <MarketingSolution />
            <CallToActionFive />
            <BusinessCaseThree />
            <CounterUpThree />
            <BusinessCaseFour />
            <TestimonialThree />
            <BlogFive />
            <BrandFive />
            <FooterFive />

        </div>
    )
}

export default HomeOne